import { CurrentUser, CurrentUserResponse } from './currentUserTypes';

export function parseCurrentUser(user: CurrentUserResponse): CurrentUser {
  const {
    display_name,
    email,
    id,
    image_id,
    is_admin,
    is_community_moderator,
    is_journalist,
    is_moderator,
    is_super_admin,
    registered,
    verified,
    user_name
  } = user;

  return {
    displayName: display_name,
    email,
    id,
    imageId: image_id,
    isAdmin: is_admin,
    isCommunityModerator: is_community_moderator,
    isJournalist: is_journalist,
    isModerator: is_moderator,
    isSuperAdmin: is_super_admin,
    isRegistered: registered,
    username: user_name,
    isEmailVerified: verified,
    isAuthorized: true
  };
}
